import Switch from "apollo-react/components/Switch";

const SwitchInput = ({
	field = {},
	meta = {},
	label,
	onChange,
	value,
	required,
	disabled,
	style,
}) => {
	return (
		<Switch
			{...field}
			label={label}
			checked={value}
			onChange={(e, checked) => onChange(checked)}
			error={meta.touched && !!meta.error}
			value={value}
			size="small"
			disabled={disabled}
			style={style}
		/>
	);
};

export default SwitchInput;
